import { Column, ColumnType } from '@mode-vegas/vegas';

export namespace VegasHelpers {
  export interface DatasetResourceColumn {
    readonly name: string;
    readonly type: string;
  }

  export function schema(columns: DatasetResourceColumn[]): Column[] {
    return columns.map((c) => {
      let type = ColumnType.STRING;

      switch (c.type) {
        case 'boolean':
          type = ColumnType.BOOLEAN;
          break;
        case 'integer':
        case 'int':
        case 'bigint':
          type = ColumnType.INTEGER;
          break;
        case 'string':
        case 'character':
        case 'character varying':
        case 'varchar':
        case 'varchar2':
        case 'nvarchar2':
        case 'text':
        case 'json':
          type = ColumnType.STRING;
          break;
        case 'float':
        case 'decimal':
        case 'double precision':
        case 'double':
        case 'real':
        case 'fixed':
        case 'number':
          type = ColumnType.FLOAT;
          break;
        case 'datetime':
        case 'date':
        case 'time':
        case 'timestamp with time zone':
        case 'timestamp':
        case 'timestamp without time zone':
          type = ColumnType.DATETIME;
          break;
      }

      return { name: c.name, type };
    });
  }
}
